function a() {
  return !1;
}
var e = a;
export {
  e as default
};
//# sourceMappingURL=stubFalse.js.map
